import { render, staticRenderFns } from "./LearningUnitMap.vue?vue&type=template&id=534d0542&scoped=true&lang=pug&"
import script from "./LearningUnitMap.vue?vue&type=script&lang=ts&"
export * from "./LearningUnitMap.vue?vue&type=script&lang=ts&"
import style0 from "./LearningUnitMap.vue?vue&type=style&index=0&id=534d0542&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534d0542",
  null
  
)

export default component.exports